import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { formatPKR } from '../../utils/formatters';
import { FiHeart, FiShoppingCart } from 'react-icons/fi';
import { useCart } from '../../context/CartContext';
import ProductImage from '../ProductImage';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const isOnSale = product.salePrice && product.salePrice < product.price;

  const handleQuickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, null, 1);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -8, rotateX: 6, rotateY: -6, scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 260, damping: 18 }}
      style={{ perspective: 1000 }}
      className="card overflow-hidden group transform-gpu"
    >
      <Link to={`/products/${product._id}`}>
        <div className="relative overflow-hidden aspect-square">
          {isOnSale && (
            <div className="absolute top-4 left-4 z-20">
              <span className="bg-primary-light text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg uppercase tracking-wider">
                Sale
              </span>
            </div>
          )}
          <ProductImage
            src={product.images && product.images[0] ? product.images[0] : ''}
            alt={product.name}
            className="w-full h-full"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-500" />
          <div className="absolute top-4 right-4 translate-x-12 group-hover:translate-x-0 transition-transform duration-500 z-20">
            <button className="bg-white/90 backdrop-blur-md dark:bg-gray-800/90 p-3 rounded-full shadow-xl hover:bg-primary-light hover:text-white transition-all transform hover:scale-110">
              <FiHeart className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="p-4">
          <h3 className="font-semibold text-lg mb-2 line-clamp-2">{product.name}</h3>
          <div className="flex items-center justify-between mb-3">
            <div>
              {isOnSale ? (
                <div>
                  <span className="text-red-500 font-bold text-lg">
                    {formatPKR(product.salePrice)}
                  </span>
                  <span className="text-gray-500 line-through ml-2 text-sm">
                    {formatPKR(product.price)}
                  </span>
                </div>
              ) : (
                <span className="font-bold text-lg">{formatPKR(product.price)}</span>
              )}
            </div>
          </div>
          <button
            onClick={handleQuickAdd}
            className="w-full btn-primary text-sm py-2 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <FiShoppingCart className="inline mr-2" />
            Quick Add
          </button>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
